import utils from "@/stuff/Utils";
import { mapData } from "@/stuff/DataMapping";

export interface IContact {
    id: number;
    regionID: number;
    supplierID: number;
    isKey: boolean;
    forename: string;
    surname: string;
    position: string;
    phone: string;
    mobile: string;
    email: string;
    doNotChase: boolean;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    deleted: Date;
    deletedByUserID: number;
}

export class Contact implements IContact {

    constructor(data?: IContact) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IContact) {
        mapData(data, { root: () => this });
    }

    id: number = 0;
    regionID: number = 0;
    supplierID: number = 0;
    isKey: boolean = false;
    forename: string = "";
    surname: string = "";
    position: string = "";
    phone: string = "";
    mobile: string = "";
    email: string = "";
    doNotChase: boolean = false;
    created: Date = new Date(utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    deleted: Date = new Date(utils.emptyDateValue);
    deletedByUserID: number = 0;

    get isNew() {
        return utils.isEmptyId(this.id);
    }

    get isDeleted() {
        return utils.hasDateValue(this.deleted);
    }

    get fullname() {
        return this.forename + " " + this.surname;
    }

    get canChase(): boolean {
        return !this.doNotChase;
    }
    set canChase(value: boolean) {
        this.doNotChase = !value;
    }

}


